function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.6014 19.1162C27.3085 18.8233 26.8337 18.8233 26.5408 19.1162L18.9394 26.7176C17.3767 28.2803 14.8452 28.2803 13.2825 26.7176C11.7198 25.1549 11.7198 22.6234 13.2825 21.0607L22.1213 12.2219C23.0972 11.2461 24.6811 11.2461 25.6569 12.2219C26.6327 13.1977 26.6327 14.7816 25.6569 15.7574L18.2323 23.1821C17.8433 23.571 17.207 23.571 16.818 23.1821C16.4291 22.7931 16.4291 22.1567 16.818 21.7678L23.0052 15.5807C23.2981 15.2878 23.2981 14.8129 23.0052 14.52C22.7123 14.2271 22.2375 14.2271 21.9446 14.52L15.7574 20.7072C14.7816 21.683 14.7816 23.2669 15.7574 24.2427C16.7332 25.2185 18.3171 25.2185 19.2929 24.2427L26.7175 16.8181C28.2802 15.2554 28.2802 12.7239 26.7175 11.1612C25.1548 9.59853 22.6234 9.59853 21.0607 11.1612L12.2219 20.0001C10.0722 22.1497 10.0722 25.6286 12.2219 27.7782C14.3715 29.9279 17.8504 29.9279 20 27.7782L27.6014 20.1768C27.8943 19.884 27.8943 19.4091 27.6014 19.1162Z",
  fill: "#979797"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/AttachFileV2.100b51d7.svg";
export { SvgComponent as ReactComponent };